import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=a0a9966a&scoped=true"
import script from "./Compass.vue?vue&type=script&lang=js"
export * from "./Compass.vue?vue&type=script&lang=js"
import style0 from "./Compass.vue?vue&type=style&index=0&id=a0a9966a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a9966a",
  null
  
)

export default component.exports